(function () {
  document.querySelectorAll('.nt-cat').forEach(function (section) {
    var back = section.querySelector('[data-nt-cat-back]');
    var front = section.querySelector('[data-nt-cat-front]');
    var labels = Array.prototype.slice.call(section.querySelectorAll('.nt-cat__label'));
    if (!back || !front || labels.length === 0) return;

    var currentIndex = 0;
    var isAnimating = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
    var speed = parseFloat(getComputedStyle(section).getPropertyValue('--nt-cat-speed')) * 1000 || 600;

    function applyLabel(label, el) {
      var mobileImage = label.getAttribute('data-nt-cat-image-mobile');
      var desktopImage = label.getAttribute('data-nt-cat-image');
      var image = (isMobileViewport && mobileImage) ? mobileImage : desktopImage;
      var color = label.getAttribute('data-nt-cat-bg');
      var focal = label.getAttribute('data-nt-cat-focal') || 'center';
      if (image) {
        el.style.backgroundImage = 'url("' + image + '")';
        el.style.backgroundColor = '';
        el.style.backgroundPosition = 'center ' + focal;
      } else {
        el.style.backgroundImage = 'none';
        el.style.backgroundColor = color || '#333333';
        el.style.backgroundPosition = '';
      }
    }

    applyLabel(labels[0], back);

    function goTo(index) {
      if (index === currentIndex || isAnimating || !labels[index]) return;
      isAnimating = true;

      applyLabel(labels[index], front);
      front.classList.remove('is-wiping');
      void front.offsetWidth;

      labels.forEach(function (l, i) {
        l.classList.toggle('is-active', i === index);
      });

      requestAnimationFrame(function () {
        front.classList.add('is-wiping');
      });

      var settle = function () {
        applyLabel(labels[index], back);
        front.classList.remove('is-wiping');
        front.style.backgroundImage = 'none';
        front.style.backgroundColor = '';
        currentIndex = index;
        isAnimating = false;
      };

      if (reduceMotion) {
        settle();
      } else {
        setTimeout(settle, speed + 40);
      }
    }

    var supportsHover = window.matchMedia('(hover: hover)').matches;

    labels.forEach(function (label, i) {
      label.addEventListener('mouseenter', function () {
        if (supportsHover) goTo(i);
      });
      label.addEventListener('focus', function () {
        goTo(i);
      });
      label.addEventListener('click', function (e) {
        if (!supportsHover && i !== currentIndex) {
          e.preventDefault();
          goTo(i);
        }
      });
    });

    var autoplayEnabled = section.getAttribute('data-autoplay-mobile') === 'true';

    if (!supportsHover && autoplayEnabled && !reduceMotion) {
      var interval = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 4000;
      setInterval(function () {
        var next = (currentIndex + 1) % labels.length;
        goTo(next);
      }, interval);
    }
  });
})();
